import React from "react";
import top_img from "../assets/images/backtotop.svg";
import iosIcon from "../assets/images/IOS_icon.png"; // Update the path as per your project structure
import playStoreIcon from "../assets/images/playStore_icon.png";

const isMobile = window.innerWidth <= 768;

const FooterComponent = () => {
  return (
    <>
    <div className="sticky--cta"><button>Apply Now</button></div>
      <footer className="footerPO">
      <div className="container">
        <div className="d-flex justify-content-between">
            <div className="term">
             {/* <p>*Terms and Conditions of ICICI Bank apply.<br/> For details visit <a href="http://www.icicicareers.com/" target="_blank">http://www.icicicareers.com/</a></p> */}
             <p>
      *Terms and Conditions of ICICI Bank apply.
      <br />
      For details download iUniverse by ICICI Bank
      {isMobile && <br/>}
      <a
        href="https://apps.apple.com/in/app/iuniverse-by-icici-bank/id6477769686"
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginLeft: "10px" }}
      >
        <img
          src={iosIcon}
          alt=""
          style={{ width: isMobile ? "50px" : "40px", verticalAlign: "middle" }}
        />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.icicibank.careers&pli=1"
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginLeft: "10px" }}
      >
        <img
          src={playStoreIcon}
          alt=""
          style={{ width: isMobile ? "50px" : "40px", verticalAlign: "middle" }}
        />
      </a>
    </p>
            </div>
            <div className="">
              <p>Corporate Office Address: ICICI Bank Towers,<br/> Bandra-Kurla Complex, Mumbai 400 051.</p>
            </div>
        </div>
      </div>
    </footer>
    </>
  );
};

export default FooterComponent;
